import { getEnv } from '@luna/env';

import { clientOptionsFactory } from './swiftIsoAddressConfiguration/clientOptions';

clientOptionsFactory.set(() => ({ baseUrl: `${getEnv().apiGatewayUrl}payment` }));
